<template>
  <div class="page-content pdf-film-fee-balance">
    <h1 class="page-title">{{ $locale("sideMenu.reports.pdfFilmFee") }}</h1>
    <!-- Search Area -->
    <el-form
      ref="form"
      class="search-area"
      :model="formData"
      label-position="top"
    >
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            prop="monthDate"
            required
            :label="$locale('pdfFilmFeeBalance.month')"
            :show-message="false"
          >
            <div class="datepicker">
              <el-button class="egl-btn-yellow month-btn" @click="getCurMonth(-1)">
                <i class="el-icon-arrow-left"></i>
              </el-button>
              <el-date-picker
                type="month"
                v-model="formData.monthDate"
                format="yyyy-MM"
                value-format="timestamp"
                :clearable="false"
                :picker-options="pickerOptions"
                @change="getCurMonth(0)"
              ></el-date-picker>
              <el-button class="egl-btn-yellow month-btn" @click="getCurMonth(1)">
                <i class="el-icon-arrow-right"></i>
              </el-button>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            prop="cinemaIds"
            required
            :label="$locale('filmFeePdf.targetTheater')"
            :show-message="false"
          >
            <el-select v-model="formData.cinemaId">
              <el-option
                v-for="item in cinemaList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-button class="download egl-btn-yellow" @click="downloadPdf" :disabled="btnDisabled">
            {{ $locale("global.download") }}
          </el-button>
        </el-col>
      </el-row>
    </el-form>

    <pdf-viewer
      ref="report"
      :filename="$locale('sideMenu.reports.pdfFilmFee')"
    >
      <film-fee-pdf :pdfData="pdfData" @printPDF="printPDF"></film-fee-pdf>
    </pdf-viewer>
  </div>
</template>

<script>
import { getCinemaList } from "@/helpers/service/api/common";
import { getFilmFeeService } from "@/helpers/service/api/pdfFilmFee";
import PdfViewer from "@/components/Report/PdfPreview.vue";
import FilmFeePdf from "@/components/PdfFilmFee/Pdf/FilmFeePdf.vue";

export default {
  name: "PdfFilmFee",
  components: {
    PdfViewer,
    FilmFeePdf,
  },
  data() {
    return {
      formData: {
        monthDate: this.$moment().startOf("month").valueOf(),
        cinemaId: "",
      },
      pdfData: {},
      pickerOptions: {
        disabledDate: this.disableMonth,
      },
      cinemaList: [],
      download: false,
    };
  },
  computed: {
    btnDisabled() {
      let result = true;
      result = Object.values(this.formData).filter(_val => !_val);

      return result.length !== 0;
    },
  },
  async created() {
    await getCinemaList({ page: 0, pageSize: 9999 }).then(res => {
      this.cinemaList = (res.data.data || []).map(({ id, name }) => {
        return {
          value: id,
          label: name
        };
      });
    });
  },
  mounted() {
    this.$refs.form.validate(() => {});
  },
  methods: {
    getCurMonth(num = 0) {
      const currentMonth = this.$moment().startOf("month").valueOf();
      const updatedMonth = num === 0 ? this.$moment(this.formData.monthDate).valueOf() : this.$moment(this.formData.monthDate).subtract(-(num), "months").valueOf();

      this.formData.monthDate = updatedMonth > currentMonth ? currentMonth : updatedMonth;
    },
    async downloadPdf() {
      const _monthDate = this.$moment(this.formData.monthDate).startOf("month").format("YYYY-MM-DD");

      await getFilmFeeService({
        ...this.formData,
        monthDate: _monthDate,
      }).then(res => {
        if (res.success) {
          this.pdfData = res.data || {};
        }
      });
    },
    printPDF() {
      this.$refs.report.generateReport();
    },
  },
};
</script>

<style scoped lang="less">
.pdf-film-fee-balance {
  position: relative;
  overflow: hidden;

  .pdf-viewer {
    position: absolute;
    z-index: -1;
  }

  .search-area {
    .datepicker {
      display: flex;

      .el-input {
        padding: 0 10px;
      }
    }

    .download {
      margin-top: 42px;
    }

    .month-btn {
      width: 54px;
      height: 40px;
      padding: 0;
    }
  }
}
</style>
